import { useEffect } from 'react';

// Hook to prevent reload or close during loading
function usePreventUnload(shouldPrevent) {
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!shouldPrevent) return;
            event.preventDefault();
            event.returnValue = ''; // Triggers the confirmation prompt
            return '';
        };

        if (shouldPrevent) {
            window.addEventListener('beforeunload', handleBeforeUnload);
        } else {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [shouldPrevent]);
}

export default usePreventUnload;